import { createSelectionListViewContainer } from 'factories/SelectionListView'
import jobTemplateActions from 'actions/jobTemplates'
import Component from 'components/Assets/Tasks/FormView/SelectJobTemplate'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) => dispatch(jobTemplateActions.getOptions(params)),
  }),
})(Component)
